<template>
    <div class="ag-cell-label-container" role="presentation">
        <div
            ref="eLabel"
            class="ag-header-cell-label flex items-center"
            role="presentation"
        >
            <span ref="eText" class="ag-header-cell-text"> Alerts </span>
            <span
                class="ms-2 rounded-full bg-gray-300 text-center leading-none"
                style="height: 1.3em; width: 1.3em; padding: 3px"
            >
                ?
                <v-menu
                    activator="parent"
                    :close-on-content-click="false"
                    location="end"
                    offset="8"
                >
                    <v-card width="auto" class="">
                        <div class="px-2 py-2 bg-gray-100">Alerts Legend</div>
                        <v-divider
                            class="border-gray-700 pb-2"
                            :thickness="1"
                        ></v-divider>
                        <div class="px-3">
                            <div class="pb-2">
                                <v-icon
                                    icon="fas fa-circle"
                                    color="#119977"
                                    size="small"
                                    class="me-1"
                                ></v-icon>
                                On-Time
                            </div>
                            <div class="pb-2">
                                <v-icon
                                    icon="fas fa-circle"
                                    color="#fbbf24"
                                    size="small"
                                    class="me-1"
                                ></v-icon>
                                Maybe Late
                            </div>
                            <div class="pb-2">
                                <v-icon
                                    icon="fas fa-circle"
                                    color="#dc2626"
                                    size="small"
                                    class="me-1"
                                ></v-icon>
                                Expected Late
                            </div>
                            <div class="pb-2">
                                <v-icon
                                    icon="fat fa-circle"
                                    color="#6c6c6c"
                                    size="small"
                                    class="me-1"
                                ></v-icon>
                                Not enough info (no ETA icon)
                            </div>
                            <v-divider
                                class="border-gray-700 pb-2"
                                :thickness="1"
                            ></v-divider>
                            <div class="pb-2">
                                <v-icon
                                    icon="far fa-clipboard-question"
                                    size="small"
                                    class="me-2"
                                ></v-icon>
                                Load has Unassigned Shipment(s)
                            </div>
                            <div class="pb-2">
                                <v-icon
                                    icon="far fa-temperature-list"
                                    size="small"
                                    class="me-2"
                                ></v-icon>
                                Load has Temp. Controlled Shipment(s)
                            </div>
                            <div class="pb-2">
                                <v-icon
                                    icon="far fa-diamond-exclamation"
                                    size="small"
                                    class="me-2"
                                ></v-icon>
                                Load has Hazmat Shipment(s)
                            </div>
                            <div class="pb-2">
                                <v-icon
                                    icon="far fa-arrow-right-arrow-left"
                                    size="small"
                                    class="me-2"
                                ></v-icon>
                                Load has Backhaul Shipment(s)
                            </div>
                            <div class="pb-2">
                                <v-icon
                                    icon="far fa-comment"
                                    size="small"
                                    class="me-2"
                                ></v-icon>
                                Load has Comments
                            </div>
                            <div class="pb-2">
                                <v-icon
                                    icon="far fa-file-binary"
                                    size="small"
                                    class="me-2"
                                ></v-icon>
                                Load has EDI Shipment(s)
                            </div>
                        </div>
                    </v-card>
                </v-menu>
            </span>
        </div>
    </div>
</template>
